import React, { useEffect } from 'react';
import { Form, Input, Row, Col } from 'antd';
import ValidatorHelper from '../helpers/ValidatorHelper';
import StringHelper from '../helpers/StringHelper';
import { useNonePersistedStore } from '../../store/non-persisted-store';
import { usePersistedStore } from '../../store/persisted-store';

export default function EditCompanyDefaultWageForm({ onSubmit, company }) {
    const { updateCompanyDefaultAgentWage } = useNonePersistedStore();
    const { users } = usePersistedStore()
    const [form] = Form.useForm();
    const loading = users.loading;

    useEffect(() => {
        if (company)
            form.setFieldsValue(company);
        else
            form.resetFields();
    }, [form, company]);

    const formLayout = {
        labelCol: {
            lg: 6,
            xs: 24
        },
        wrapperCol: {
            lg: 16,
            xs: 24
        }
    }
    const itemLayout = {
        lg: 12,
        md: 12,
        sm: 24,
        xs: 24
    }

    function onFinish(values) {
        const params = {
            CompanyBranchId: company.CompanyBranchId,
            DefaultAgentWagePercent: parseFloat(StringHelper.getEnglishNum(values.DefaultAgentWagePercent)),
            DefaultAgentWagePrice: parseInt(values.DefaultAgentWagePrice)
        };
        updateCompanyDefaultAgentWage({ params: params, cb: onSubmit, reset: () => form.resetFields() })
    };

    return (
        <Form
            form={form}
            name="user-form"
            className='business-form'
            {...formLayout}
            onFinish={onFinish}>
            <Row>
                <Col {...itemLayout}>
                    <Form.Item
                        rules={[
                            ...ValidatorHelper.decimalNumber('درصد کارمزد')
                        ]}
                        name="DefaultAgentWagePercent"
                        label="درصد کارمزد">
                        <Input />
                    </Form.Item>
                </Col>
                <Col {...itemLayout}>
                    <Form.Item
                        rules={[
                            ...ValidatorHelper.number('مبلغ کارمزد')
                        ]}
                        name="DefaultAgentWagePrice"
                        label="مبلغ کارمزد">
                        <Input />
                    </Form.Item>
                </Col>
            </Row>
            <button type="primary" className="btn btn-primary waves-effect waves-light" htmltype="submit" style={{ width: "100%" }}>
                <i className={`${loading ? "bx bx-loader bx-spin" : "bx bx-check-double"} "font-size-14 align-middle mr-2 ml-3"`}></i>ثبت
            </button>
        </Form >
    )
}
